import moment from 'moment'

export function getExpansionFile(fileName) {
  return fileName.match(/\.(\w*$)/)[1]
}

export function splitEventsByDay(events) {
  if (!events) return { list: [], stats: {}, interval: {} }
  let stats = {}
  let interval = { start: events[0]?.time_start, end: 0 }

  const list = events.reduce((list, event) => {
    const date = moment(event.time_start).startOf('day')
    if (!list[+date]) list[+date] = []
    list[+date].push(event)

    stats[event.type.id] = stats[event.type.id] + 1 || 1
    interval.start = Math.min(interval.start, event.time_start)
    interval.end = Math.max(interval.end, event.time_finish)
    return list
  }, {})

  return {
    list,
    stats,
    interval,
  }
}
